// DashboardHome.jsx
import React from 'react';
import './DashboardHome.css';
import FirstPage from './FirstPage';
import UserProfile from './UserProfile'; // ✅ Import UserProfile

const DashboardHome = () => {
  return (
    <div className="dashboard-container">
      {/* ✅ UserProfile shown at top */}
      <UserProfile />

      {/* ✅ FirstPage embedded below UserProfile */}
      <div className="firstpage-section">
        <FirstPage />
      </div>

      {/* Hero Section */}
<div className="hero">
  <h1 className="hero-title">🤖 Vortrex AI Bot</h1>
  <p className="hero-sub">Trade Smarter with Your Own Wallet. 100% Control. No KYC. No Deposits.</p>
  <ul className="hero-points">
    <li>🔐 Secure Wallet Connection</li>
    <li>📊 Trades BTC, ETH, BNB</li>
    <li>💰 Profit Tracking in Real-Time</li>
  </ul>
  <a
    href="https://vortrexai.site/connect-wallet"
    className="wallet-connect-btn demo-mode-btn"
  >
    🚀 Try in Demo Mode
  </a>
</div>

      {/* Live Demo Simulation */}
      <div className="demo-section">
        <h2>📈 Top Indicators (AI Signals)</h2>
        <div className="demo-cards">
          <div className="card"><strong>📈 Market Trend:</strong> Bullish Momentum</div>
          <div className="card"><strong>🔄 RSI Status:</strong> Overbought (72)</div>
          <div className="card"><strong>📌 Signal:</strong> Wait for pullback before buy</div>
        </div>
        <p className="demo-note"> AI indicators scan real-time data from BTC, ETH, and BNB pairs.</p>
      </div>

<div className="how-it-works">
  <h2>🔍 How Vortrex AI Bot Trades Smartly</h2>
  <ol>
    <li>AI connects with your wallet (MetaMask, TrustWallet)</li>

    <li>
      It monitors 10+ key indicators including:
      <ul className="indicator-list">
        <li>RSI</li>
        <li>MACD</li>
        <li>EMA Cross</li>
        <li>Bollinger Bands</li>
        <li>Volume Surge</li>
        <li>Trend Strength Index</li>
        <li>Volatility Index (VIX)</li>
        <li>Momentum Shift</li>
        <li>Order Book Imbalance</li>
        <li>Whale Wallet Movement</li>
      </ul>
    </li>

    <li>Trade triggers <strong>only when 7+ indicators align perfectly</strong></li>
    <li>Orders are placed directly from your wallet via smart execution</li>
    <li>Real-time risk control ensures stop-loss & profit-lock automation</li>
  </ol>
</div>

      {/* Live Metrics */}
<div className="live-metrics">
  <div className="metric">🧠 Signal Accuracy: <strong>91.2%</strong></div>
  <div className="metric">📉 Avg Drawdown: <strong>-1.3%</strong></div>
  <div className="metric">⚡ Execution Speed: <strong>0.8s</strong></div>
  <div className="metric">📊 Market Coverage: <strong>BTC, ETH, BNB</strong></div>
</div>

      {/* Strategy Info */}
<div className="strategy">
  <h2>📋 Trade Logic Intelligence</h2>
  <p>
    Our AI dynamically combines 10+ indicators including <strong>RSI</strong>, <strong>MACD</strong>, <strong>Bollinger Bands</strong>, <strong>EMA</strong>, <strong>Order Flow</strong>, and <strong>Whale Wallet Activity</strong>.
  </p>
  <p>📈 It adapts to market volatility in real-time using:</p>
  <ul>
    <li>📊 <strong>Trend Confirmation</strong> (EMA, VWAP)</li>
    <li>⚡ <strong>Momentum Strength</strong> (RSI, MACD, ADX)</li>
    <li>📉 <strong>Order Book Heat</strong> (Liquidity Gaps, CVD)</li>
    <li>🐋 <strong>On-Chain Data</strong> (Whale Moves, Token Flow)</li>
  </ul>
  <p>⛔ No leverage, no martingale — only calculated risk via <strong>Smart SL/TP automation</strong>.</p>
</div>


      {/* Security Badges */}
<div className="security">
  <h2>🛡️ Security & Trust</h2>
  <ul>
    <li>✅ 100% Non-Custodial – Your funds stay in your wallet</li>
    <li>🔒 Trade-Only Access – Vortrex AI can trade but <strong>cannot withdraw</strong> your assets</li>
    <li>❌ No API Keys Required – No exchange keys or credentials needed</li>
    <li>📄 Transparent On-Chain Activity – Every trade is recorded on-chain</li>
    <li>📉 Risk Control – Only trades when <strong>7+ indicators align</strong></li>
    <li>📊 70% Success Rate – Based on backtests, approx. 7 out of 10 trades are profitable</li>
    <li>🛑 No Leverage – Spot-only trades with Smart SL/TP automation</li>
    <li>🧠 You stay in control – Revoke access anytime from your wallet</li>
  </ul>
</div>

      {/* Testimonials */}
      <div className="testimonials">
        <h2>🗣️ What Users Say</h2>
        <blockquote>“I tested Vortrex AI with 0.05 ETH and saw 7% gain in 2 days!” — Abhishek, Mumbai</blockquote>
        <blockquote>“Loved the transparency. No shady signup, just connect wallet and go.” — Anjali, Delhi</blockquote>
      </div>

      {/* FAQs */}
<div className="faqs">
  <h2>❓ FAQs</h2>
  <ul>
    <li><strong>Is it safe?</strong> ✅ Yes, the bot never withdraws funds. It only trades using your wallet — you stay in control.</li>
    <li><strong>Do I need to deposit?</strong> ❌ No deposit needed. Trades happen directly from your wallet balance.</li>
    <li><strong>Can it lose money?</strong> ⚠️ Losses are rare. Vortrex AI only trades when 7+ indicators align. 70%+ of trades are historically profitable.</li>
    <li><strong>What coins are supported?</strong> 💹 BTC, ETH, BNB</li>
    <li><strong>Can I test it?</strong> 🧪 Yes! Use Demo Mode completely free — no wallet access required.</li>
    <li><strong>Does it require API or coding?</strong> 🛠️ No APIs or technical setup needed. Just connect and trade.</li>
    <li><strong>Can I disconnect anytime?</strong> 🔓 Yes, you can revoke wallet access anytime from your wallet settings.</li>
  </ul>
</div>

{/* CTA Footer */}
<div className="footer-cta">
  <a
    href="https://vortrexai.site/connect-wallet"
    className="wallet-connect-btn footer-connect-btn"
  >
    🔗 Connect Wallet & Launch Bot
  </a>
</div>
</div>
);
};

export default DashboardHome;
